// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"f9880f41","374":"aaedbf26","438":"387cc76a","706":"be35db4b","726":"93e3b635"}[chunkId] + ".chunk.js";
};